import VueRecaptcha from 'vue-recaptcha'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapActions, mapGetters } from 'vuex'

import config from '@/config'
import gaMixin from '@/mixins/ga'

import Icon from '@/components/icon'

export default {
  mixins: [gaMixin],
  components: {
    appIcon: Icon,
    'vue-recaptcha': VueRecaptcha
  },
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      siteKey: config.RECAPTCHA_SITE_KEY,
      token: null
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required
    },
    message: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(300)
    },
    token: {
      required
    }
  },
  computed: {
    ...mapState('tours', ['agent', 'id']),
    ...mapState('contact', ['loading']),
    ...mapGetters('tour', ['getButtonColor'])
  },
  methods: {
    ...mapActions('contact', ['sendEmail']),
    ...mapActions('utils', ['openNotification', 'closeNotification']),
    initRecaptcha () {
      let script = document.createElement('script')
      script.src = config.RECAPTCHA_URL
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    },
    onVerify (response) {
      this.token = response
    },
    onExpired () {
      this.token = null
    },
    onSend () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.sendEmail({
        id: this.id,
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message,
        contact_email: this.agent.email,
        token: this.token
      })
      .then(() => {
        this.openNotification({type: 'success', message: 'Thank you for the message!'})
        this.resetForm()
        this.sendEventGA('Contact', 'Send Form', 'Sent')
      })
      .catch(() => {
        this.openNotification({type: 'error', message: 'Error :('})
        this.resetForm()
      })
    },
    resetForm () {
      setTimeout(() => {
        this.name = ''
        this.email = ''
        this.phone = ''
        this.message = ''
        this.token = null

        this.$v.$reset()
        this.$refs.recaptcha.reset()
        this.closeNotification()
      }, 3000)
    }
  },
  mounted () {
    this.initRecaptcha()
  }
}
